import { useaxios } from "../../../utils/useaxios";
export default (sell_invoice_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    initDispatch({ type: 'loadingTrue' });
    useaxios('sell_invoice/delete.php', { sell_invoice_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setreturnbybarcode', payload: [] });
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}